<div class="disclaimer-band">
  <div class="container">
    <div class="disclaimer">
      <h4 class="toggle-trigger" id="hdr-disclaimer" #discalimer (click)="toggle(discalimer.id)"> Disclaimer </h4>
      <p class="toggle-panel">
        Southern Cross Health Society (Southern Cross) has made the Healthcare finder available to assist its members
        and others in finding a health services provider in their area. While Southern Cross will endeavour to keep the
        contents of the Healthcare finder up to date, accurate and complete we do not warrant or represent to any user
        or other third party that such content is accurate, up to date or complete at all times. The Southern Cross
        website
        <a href="http://www.southerncross.co.nz/terms-of-use" target="_blank"> Terms of Use </a>
        apply to any use of the Healthcare finder. Any listing of any healthcare provider on the Healthcare finder in no
        way indicates any recommendation or endorsement of a healthcare provider by Southern Cross. Any use of the
        Healthcare finder or a particular provider is at the user's own risk.<br />Where you have allowed us to track
        your physical location we will only use this information to sort the results you see on Healthcare Finder, and
        will not share this information with any third parties.
      </p>
    </div>
  </div>
</div>
<div class="sx-links">
  <div class="container">
    <h4 class="toggle-trigger" id="hdr-quick-links" #quicklinks (click)="toggle(quicklinks.id)"> Quick links </h4>
    <div class="toggle-panel">
      <div class="links">
        <nav>
          <h5 class="heading">What we offer</h5>
          <ul class="plain-list">
            <li>
              <a href="https://join.southerncross.co.nz/quote" target="_blank"> Quote and apply </a>
            </li>
            <li>
              <a
                href="https://www.southerncross.co.nz/society/buying-health-insurance/our-plans/critical-illness"
                target="_blank">
                Critical Illness insurance
              </a>
            </li>
            <li>
              <a href="https://www.southerncross.co.nz/society/for-members/my-southern-cross" target="_blank">
                My Southern Cross
              </a>
            </li>
            <li>
              <a href="https://healthcarefinder.southerncross.co.nz/" target="_blank"> Affiliated Providers </a>
            </li>
          </ul>
        </nav>
        <nav>
          <h5 class="heading">Who we're for</h5>
          <ul class="plain-list">
            <li>
              <a href="https://www.southerncross.co.nz/society/buying-health-insurance" target="_blank">
                New members
              </a>
            </li>
            <li>
              <a href="https://www.southerncross.co.nz/society/for-members" target="_blank"> Existing members </a>
            </li>
            <li>
              <a href="https://www.southerncross.co.nz/society/for-health-professionals" target="_blank">
                Health professionals
              </a>
            </li>
            <li>
              <a href="https://www.southerncross.co.nz/business" target="_blank"> Businesses </a>
            </li>
            <li>
              <a href="https://www.southerncross.co.nz/society/for-advisers" target="_blank"> Advisers </a>
            </li>
          </ul>
        </nav>
        <nav>
          <h5 class="heading">Other Southern Cross Group sites</h5>
          <ul class="plain-list">
            <li>
              <a href="https://healthcare.southerncross.co.nz" target="_blank"> Healthcare services </a>
            </li>
            <li>
              <a href="https://healthcare.southerncross.co.nz/specialists-and-services" target="_blank"> Hospitals </a>
            </li>
            <li>
              <a href="https://www.southerncrosspet.co.nz" target="_blank"> Pet Insurance </a>
            </li>
            <li>
              <a href="https://www.scti.co.nz" target="_blank"> Travel Insurance </a>
            </li>
            <li>
              <a href="https://www.southerncrosslife.co.nz" target="_blank"> Life Insurance </a>
            </li>
            <li>
              <a href="https://www.southerncross.co.nz/about-southern-cross" target="_blank"> About the Group </a>
            </li>
          </ul>
        </nav>
        <nav>
          <h5 class="heading">Important information</h5>
          <ul class="plain-list">
            <li>
              <a href="https://www.southerncross.co.nz/society/financial-strength-solvency-and-legal" target="_blank">
                Financial strength Solvency and Legal
              </a>
            </li>
            <li>
              <a href="https://www.southerncross.co.nz/privacy" target="_blank"> Member privacy statement </a>
            </li>
            <li>
              <a href="https://www.southerncross.co.nz/cookies" target="_blank"> Cookies policy </a>
            </li>
            <li>
              <a href="https://www.southerncross.co.nz/complaints" target="_blank"> Complaints disclosure </a>
            </li>
            <li>
              <a href="https://www.southerncross.co.nz/society/buying-health-insurance/trust-centre" target="_blank">
                Trust centre
              </a>
            </li>
            <li>
              <a href="https://www.southerncross.co.nz/society/terms-and-conditions" target="_blank">
                Terms and conditions
              </a>
            </li>
          </ul>
        </nav>
        <nav>
          <h5 class="heading">Quick links</h5>
          <ul class="plain-list">
            <li>
              <a href="https://www.southerncross.co.nz/society/for-members/Making-a-claim" target="_blank"> Claims </a>
            </li>
            <li>
              <a href="https://www.southerncross.co.nz/society/careers" target="_blank"> Careers </a>
            </li>
            <li>
              <a
                href="https://www.southerncross.co.nz/society/for-members/Making-a-claim/Request-cover-or-prior-approval"
                target="_blank">
                Request cover or prior approval
              </a>
            </li>
            <li>
              <a
                href="https://www.southerncross.co.nz/society/for-members/managing-your-policy/plan-documents"
                target="_blank">
                Plan documents
              </a>
            </li>
            <li>
              <a href="https://www.southerncross.co.nz/society/buying-health-insurance/our-plans" target="_blank">
                Health insurance plans
              </a>
            </li>
            <li>
              <a href="https://www.facebook.com/SouthernCrossHealthSociety/" target="_blank"> Facebook </a>
            </li>
          </ul>
        </nav>
        <nav>
          <h5 class="heading">Help links</h5>
          <ul class="plain-list">
            <li>
              <a href="https://www.southerncross.co.nz/society/Help" target="_blank"> Member FAQs </a>
            </li>
            <li>
              <a href="https://www.southerncross.co.nz/society/contact" target="_blank"> Contact </a>
            </li>
            <li>
              <a
                href="https://www.southerncross.co.nz/society/for-members/managing-your-policy/new-member-card"
                target="_blank">
                New Member card
              </a>
            </li>
            <li>
              <a href="https://www.southerncross.co.nz/society/for-members/glossary-of-terms" target="_blank">
                Medical terms glossary
              </a>
            </li>
            <li>
              <a href="https://www.southerncross.co.nz/news" target="_blank"> Media releases </a>
            </li>
            <li>
              <a href="https://www.southerncross.co.nz/society/contact/complaints" target="_blank"> Complaint form </a>
            </li>
            <li>
              <div id="womensRefugeBadge"></div>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</div>
<div class="sx-websites">
  <div class="container">
    <h4 class="toggle-trigger" id="hdr-websites" #websites (click)="toggle(websites.id)"> Southern Cross websites </h4>
    <ul class="plain-list toggle-panel">
      <li class="websites-header">
        <a href="https://www.southerncross.co.nz" target="_blank">
          <h4>Go to Southern Cross websites</h4>
        </a>
      </li>
      <li>
        <a href="https://www.southerncross.co.nz/society" target="_blank">Health Insurance</a>
      </li>
      <li>
        <a href="https://healthcare.southerncross.co.nz" target="_blank">Healthcare & Hospitals</a>
      </li>
      <li>
        <a href="https://www.southerncrosspet.co.nz/" target="_blank">Pet Insurance</a>
      </li>
      <li>
        <a href="https://www.scti.co.nz/" target="_blank">Travel Insurance</a>
      </li>
      <li>
        <a href="https://www.southerncrosslife.co.nz/" target="_blank">Life Insurance</a>
      </li>
      <li>
        <a href="https://www.southerncross.co.nz/about-southern-cross" target="_blank">About the Group</a>
      </li>
    </ul>
  </div>
</div>
<div class="copyrightpanel">
  <div class="container">
    <div class="copyrighttext">&copy; Southern Cross Medical Care Society</div>
    <ul class="plain-list copyrightlinks">
      <li id="feedbackLink"></li>
      <li>
        <a href="http://www.southerncross.co.nz/terms-of-use" target="_blank"> Terms of use </a>
      </li>
      <li>
        <a href="https://www.southerncross.co.nz/society/financial-strength-solvency-and-legal" target="_blank">
          Financial Strength Rating and Solvency
        </a>
      </li>
    </ul>
  </div>
</div>
<div class="rating">
  <div class="container">
    <p>
      Southern Cross Medical Care Society (trading as Southern Cross Health Society) is a licensed insurer and a
      licensed financial advice provider. For more information about the financial advice service we provide and a copy
      of our public disclosure statement please visit
      <a href="http://southerncross.co.nz/disclosure-statement" target="_self"
        >southerncross.co.nz/disclosure-statement</a
      >.
    </p>
    <p>
      Southern Cross Medical Care Society (trading as Southern Cross Health Society) has an A+ (Strong) financial
      strength rating given by Standard &amp; Poor's (Australia) Pty Limited. The rating scale is: AAA (Extremely
      Strong), AA (Very Strong), A (Strong), BBB (Good), BB (Marginal), B (Weak), CCC (Very Weak), CC (Extremely Weak),
      SD or D (Selective Default or Default). Ratings from 'AA' to 'CCC' may be
      modified by the addition of a plus (+) or minus (-) sign to show relative standing within the major rating
      categories. Full details of the rating scale are available at
      <a target="_blank" href="https://www.spglobal.com/ratings/en/about/intro-to-credit-ratings">S&P Global Ratings</a>. Standard &amp; Poor's is
      an approved rating agency under the Insurance (Prudential Supervision) Act 2010.
    </p>
  </div>
</div>
